var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRarible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.6 113.6",
    style: {
      enableBackground: "new 0 0 113.6 113.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.6,56.8v32.4c0,13.9-10.5,24.4-24.4,24.4c-21.6,0-43.2,0-64.7,0c-14,0-24.5-10.5-24.5-24.5C0,67.6,0,46,0,24.4 C0,10.5,10.5,0,24.4,0h64.8c13.9,0,24.4,10.5,24.4,24.4L113.6,56.8z M78.2,56.2c0.6-0.3,0.8-0.5,1.1-0.6c7.1-2.9,6.8-14,0.3-17.5 c-2.9-1.6-6.1-2.1-9.3-2.2c-13.4-0.1-26.9-0.1-40.3-0.2c-1.7,0-1.6,0.8-1.6,2v37.1c0,1.6,0.5,1.9,2,1.9c4.1-0.1,8.3-0.1,12.4,0 c1.7,0.1,2.1-0.6,2-2.1c-0.1-3.4,0-6.8-0.1-10.2c0-1.2,0.3-1.6,1.5-1.6c6.1,0.1,12.1,0,18.2,0.1c3,0.1,4.3,1.5,4.4,4.5 c0.1,2.4,0.1,4.8,0,7.2c-0.1,1.5,0.3,2.2,2,2.1c4.1-0.1,8.3-0.1,12.4,0c1.8,0.1,2-0.6,2-2.1c-0.1-2-0.1-4,0-6 C85.5,63.2,84.1,58.7,78.2,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,47.3h9.9c1.9,0,3.1,0.8,3.1,2.7c0,1.8-1.1,2.8-3.1,2.8c-6.7,0-13.4,0-20.1,0c-1.3,0-1.9-0.3-1.7-1.6 c0.1-0.7,0.1-1.5,0-2.2c-0.1-1.3,0.3-1.7,1.6-1.7C49.8,47.4,53.2,47.3,56.6,47.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRarible);
export default __webpack_public_path__ + "static/media/rarible.e7c0bbfc771361e6216dbb8eb85668cd.svg";
export { ForwardRef as ReactComponent };